import { createServiceClient } from "./axiosClient";

const apiUtils = createServiceClient("/utils");

const print = async (params) => await apiUtils.post("/print", params);

export const getMessageFromError = (error) => {
  const message =
    (error.response && error.response.data && error.response.data.message) ||
    error.message ||
    error.toString();
  return message;
};

const utilsService = {
  print,
  getMessageFromError,
};

export default utilsService;
